import{fetchNews}from"Api/News";import{createEntitiesModel}from"Model/Factory";export const News=createEntitiesModel(fetchNews);